import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getSubscriptionStatus } from '../services/profile';

export default function PremiumRoute({ children }) {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    async function check() {
      try {
        const { subscribed } = await getSubscriptionStatus();
        setAllowed(subscribed);
      } catch {
        setAllowed(false);
      }
    }
    check();
  }, []);

  if (allowed === null) return null; // loading
  return allowed ? children : <Navigate to="/subscribe" replace />;
}
